import React from 'react';
import ResponsibleGamingTimers from '../../../../responsible-gaming/timers/ResponsibleGamingTimers';

export default function CoolbetHeaderAuthenticatedClock() {
    return <ResponsibleGamingTimers className="clock" />;
}
